import React from 'react';
import MyName from '../my-name';
import MyPicture from '../my-picture';
import CompletionCertificate from '../completion-certificate';
import NameTracingPrekTo1 from '../name-tracing-prek-to-1';
import { translate } from '../../translations/translator';
const t = key => translate('worksheet', key);

/** Key is sheetId */
const Map = {
  0: {
    name: 'myName',
    Component: props => <MyName {...props} isOneLine noFooterText />
  },
  1: {
    name: 'myPicture',
    Component: props => <MyPicture {...props} isOneLine noFooterText />
  },
  2: {
    name: 'certificateOfCompetion',
    Component: props => (
      <CompletionCertificate
        {...props}
        images={[
          {
            name: 'goldfish',
            width: 220,
            height: 200,
            margin: '50px 15px 0'
          },
          {
            name: 'stripedFish',
            width: 200,
            height: 150,
            margin: '75px 15px 0'
          },
          {
            name: 'flowyFinsFish',
            width: 240,
            height: 240,
            margin: '35px 15px 0'
          }
        ]}
        completedTitle={t('myFirstSchoolBook')}
        isOneLine
        isWide
      />
    )
  },
  3: {
    name: 'myNameTitleCase',
    Component: props => <MyName {...props} isWide isExtraWide noFooterText />
  },
  4: {
    name: 'nameTracing',
    Component: props => <NameTracingPrekTo1 {...props} isWide isExtraWide />
  }
};

export default Map;
